
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'MenuFooter'
})
export default class MenuFooter extends Vue {
  @Prop({ type: Array, required: true }) menu: any

  get splitedMenu() {
    return [this.menu.slice(0, 4), this.menu.slice(4, this.menu.length)]
  }

  get itemWidth() {
    return items => (this.$store.getters['screen/resolution'] >= 768)
      ? (100 / items) + '%'
      : 'auto'
  }
}

